import { render, staticRenderFns } from "./AttachmentPopoverTable.vue?vue&type=template&id=73ff7175&scoped=true&"
import script from "./AttachmentPopoverTable.vue?vue&type=script&lang=js&"
export * from "./AttachmentPopoverTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff7175",
  null
  
)

export default component.exports